<template>
  <div
    class="border rounded pl-2 py-1 pr-3 mb-1 d-flex"
    :class="{ 'border-primary': isThisGuestMySelf(guest.userName) }"
  >
    <!-- データ前半 -->
    <div>
      <div class="mb-1">
        <div class="my-1">
          キャラクター名 :
          <strong
            v-if="getMyCharacterName(guest.userName)"
          >{{ getMyCharacterName(guest.userName) }}</strong>
          <span v-else></span>
        </div>
        <span>プレイヤー名 : {{ guest.name }}</span>
        <!-- <span v-if="isRoomMaster">(管理人)</span> -->
        <!-- <span v-if="isThisGuestMySelf(guest.userName)">[[自分]]</span> -->
        <!-- <span>
          <b-button class="ml-2" variant="outline-primary" @click="removeGuestAction">削除</b-button>
        </span>-->
      </div>
      <div class="my-1">密談場所 : {{ getMyGroupId(guest.userName) }}</div>
    </div>
    <!-- キャラ画像 -->
    <!-- <div>
                <b-card
                  v-for="character in getMyCharacter(guest.name)"
                  :key="character.id"
                  :title="character.name"
                >
                  <amplify-s3-album
                    :path="game.id + '/' + character.name + '/open'"
                  />
                </b-card>
    </div>-->

    <!-- 持っているカードリスト -->
    <div class="ml-4">
      <div>持っているカード :</div>
      <div class="d-flex">
        <!-- カード -->
        <div
          class="game-card d-flex flex-column ml-1 mt-2 p-2"
          v-for="card in getMyNameCardList(guest.userName)"
          :key="card.id"
        >
          <div v-if="card.isAllOpen">全体に表示</div>
          <div v-if="card.isGroupOpen">密談相手に表示</div>
          <b-card class="border-0">
            <div>表 : {{ card.faceUpString }}</div>
          </b-card>
          <b-card class="border-0" v-if="isViewCard(card)">
            <div>裏 : {{ card.faceDownString }}</div>
          </b-card>
          <b-button
            variant="outline-primary"
            v-if="isMyCard(card.editor)"
            @click="allOpen(card)"
          >(全体に)表示切り替え</b-button>
          <b-button
            variant="outline-primary"
            v-if="isMyCard(card.editor)"
            @click="groupOpen(card)"
          >(密談相手に)表示切り替え</b-button>
          <b-button
            variant="outline-primary"
            v-if="isMyCard(card.editor)"
            @click="showMoveModal(card.id)"
          >(密談相手に)カードを移動</b-button>
        </div>
      </div>
    </div>
    <b-modal :id="'move-modal-guest' + guest.id " hide-footer>
      <template v-slot:modal-title>カードを移動する</template>
      <b-form inline class="col" @submit.prevent="onMoveCardForm2">
        <b-form-group label="相手" label-for="targetGuest">
          <b-form-select
            id="targetGuest"
            v-model="moveCardEvent.editor"
            :options="getTargetPlayerOptions"
            required
          ></b-form-select>
        </b-form-group>

        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="outline-primary" class="mr-1">移動</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import UserStore from "@/store/index.js";

export default {
  props: [
    "guest",
    "cardList",
    "characterList",
    "groupList",
    "guestList",
    "isRoomMaster"
  ],
  data() {
    return {
      moveCardEvent: {
        id: "",
        editor: ""
      },
      cardId: ""
    };
  },
  methods: {
    onMoveCardForm2() {
      // console.log("guest view movecardEvent", this.moveCardEvent);
      this.$emit(
        "onMoveCardForm",
        "move-modal-guest" + this.guest.id,
        this.moveCardEvent
      );
    },
    // 移動モーダルを表示
    showMoveModal(cardId) {
      // console.log(cardId);
      this.moveCardEvent.id = cardId;
      // console.log(this.moveCardEvent);
      this.$bvModal.show("move-modal-guest" + this.guest.id);
      // console.log(this.moveCardEvent);
    },
    // ゲスト削除
    removeGuestAction() {
      this.$emit("removeGuestAction");
    },
    allOpen(targetCard) {
      targetCard.isAllOpen = !targetCard.isAllOpen;
      this.$emit("updateAll");
    },
    groupOpen(targetCard) {
      targetCard.isGroupOpen = !targetCard.isGroupOpen;
      this.$emit("updateAll");
    }
  },
  computed: {
    // このゲストは自分か
    isThisGuestMySelf() {
      return userName => userName === UserStore.state.user.username;
    },
    // 自分のカードを取得
    getMyNameCardList() {
      // console.log(this.cardList);
      return str => {
        return this.cardList.filter(card => card.editor === str);
      };
    },
    //自分がロール中のキャラクター
    getMyCharacterName() {
      return str => {
        const role = this.characterList.find(chara => chara.editor === str);
        if (role) {
          return role.name;
        } else {
          return null;
        }
      };
    },
    //参加グループのインデックスを返す
    getMyGroupId() {
      return userName => {
        const index = this.groupList.findIndex(group =>
          group.members.some(str => {
            return str === userName;
          })
        );
        if (index >= 0) {
          return index;
        } else {
          return null;
        }
      };
    },
    // 自分のカードかどうか
    isMyCard() {
      return editor => editor === UserStore.state.user.username;
    },

    getTargetPlayerOptions() {
      let group = this.groupList.find(group =>
        group.members.some(str => str === UserStore.state.user.username)
      );

      // console.log("group", group);

      if (group != null) {
        return group.members.map(userName => {
          let guest = this.guestList.find(gue => gue.userName === userName);
          // console.log("guest", guest);
          return { value: userName, text: guest.name };
        });
      } else {
        return [];
      }
    },

    isViewCard() {
      return card => {
        // カードの持ち主なら表示
        if (card.editor === UserStore.state.user.username) {
          return true;
        }

        // カードが全体表示なら
        if (card.isAllOpen) {
          return true;
        }

        if (card.isGroupOpen) {
          // グループに入っているなら、
          let myGroup = this.groupList.find(group =>
            group.members.some(str => str === UserStore.state.user.username)
          );

          if (myGroup != null) {
            // memberが持っているカードのリスト
            let cardList = myGroup.members.flatMap(member =>
              this.cardList.filter(card => card.editor === member)
            );
            if (
              // メンバーが持っているカードなら
              cardList.some(groupMembersCard => groupMembersCard.id === card.id)
            ) {
              return true;
            }
          }
        }

        return false;
      };
    }
  }
};
</script>

<style>
.game-card {
  border: medium solid #dee2e6;
}
</style>